export default __webpack_public_path__ + "static/media/square-tick.23df800f.svg";